<div class="db-dashboard" (touchmove)="touchMove()">
  <db-page-loading-bar *ngIf="!prefilledAi"></db-page-loading-bar>
  <div class="db-dashboard__content {{routeData?.pageId}}">
<!--    <db-info-banner>
      <db-exclusive-deal
        *ngIf="hasGlobalBanner"
        [user]="user"
        [userSubscription]="userSubscription"></db-exclusive-deal>
    </db-info-banner>-->
    <div class="db-dashboard__container" [ngClass]="{'with-banner': hasGlobalBanner}">
      <!--<db-main-sidebar-empty
        *ngIf="routeData && !hideEmptySidebarPages.includes(routeData?.pageId) && (builderHistoryService.builderStep|async) !== builderSteps.SHOW_CANVAS && !showEmptySidebar && !routeData.hasMainSidebar"></db-main-sidebar-empty>-->
        <db-primary-sidebar
          *ngIf="!_websiteConnectHelperService.hideSidebars.value && !routeData?.hasMainAiSidebar && routeData?.hasMainSidebar
        && (routeData?.pageId !== 'add-website'
        || (routeData?.pageId === 'add-website' && userSubscription?.product_id === '198'))"
          class="db-dashboard__main-sidebar"
          [ngClass]="{'db-toggled' : toggleSidebar}"
          [hasGlobalBanner]="hasGlobalBanner"
          [hasHostingOfferBanner]="routeData?.hasHostingOfferBanner"></db-primary-sidebar>

      <div class="db-dashboard__main-content">
        <db-main-header
          *ngIf="showEmptySidebar && !_websiteConnectHelperService.hideSidebars.value && !routeData?.hasMainAiSidebar && ((routeData?.hasMainHeader && routeData?.pageId !== 'add-website')
          || ( routeData?.pageId === 'add-website' && userSubscription?.product_id !== '198' && !user?.oneProductOrBundleClient
          && ((userSubscription?.trialClient && !userSubscription.isExpired) || !userSubscription?.trialClient)))
          && !['invited'].includes(currentWorkspace?.status)"
          class="db-dashboard__main-header db-dashboard__content-header"
          [ngClass]="{'websites-page' : routeData?.pageId === 'websites',
                      'db-custom-header' : routeData?.pageId === 'builder-trial',
                      'knowledge-base-opened' : (toggledKnowledgeBase$ | async)}"
          [annualSubscription]="annualSubscription"
          [monthlyPrice]="monthlyPrice"
          [annualPriceForCurrent]="annualPriceForCurrent"
          [headerTitle]="routeData?.title"
          [isGeo]="isGeo"
          (onToggleClick)="setToggle($event)"
          [toggleSidebar]="toggleSidebar"></db-main-header>
        <div style="display: flex; flex-grow: 1; height: calc(100% - 50px)">
          <db-website-sidebar class="db-dashboard__website-sidebar {{toggleSidebar}}"
                              *ngIf="!routeData?.hasMainAiSidebar && routeData?.hasSecondarySidebar"
                              [ngClass]="{'db-toggled' : (toggleSidebar && user?.planType !== UserSubscriptionType.FREE && user?.planType !== UserSubscriptionType.PLATFORM && user?.planType !== UserSubscriptionCategory.DedicatedVM)
                            || ((user?.planType === UserSubscriptionType.FREE || user?.planType === UserSubscriptionType.PLATFORM || user?.planType === UserSubscriptionType.DEDICATEDVM) && this.websiteSidebarToggle$ | async),
                             'only-website-sidebar': user?.planType === UserSubscriptionType.FREE || user?.planType === UserSubscriptionType.PLATFORM}"
                              (onToggleClick)="setToggle($event)"
                              [hasBanner]="!!hasGlobalBanner"
                              [toggleSidebar]="toggleSidebar"></db-website-sidebar>
          <div class="db-chat-overlay" *ngIf="(chatOverlay$ | async)"></div>
          <div class="db-main-content-wrap"
               [ngClass]="{'with-empty-main-sidebar': !routeData?.hasMainSidebar && !routeData?.hasMainAiSidebar}">
            <db-recharge-header-banner
              *ngIf="currentWorkspaceRoleId && ![clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(currentWorkspaceRoleId) && routeData?.hasMainHeader && routeData?.hasMainSidebar && routeData?.queryParams && routeData?.queryParams.tabId !== 'subscription-plan'"></db-recharge-header-banner>
            <div class="db-dashboard__page-content"
                 [ngClass]="{'db-router-checkout': (['checkout', 'sign-up', 'mobile-sign-up', 'mobile-sign-up-email', 'setup'].includes(routeData?.pageId)),
                 'small-content': !isMobile && (toggledKnowledgeBase$ | async), 'db-recharge': userSubscription?.recharge}">
              <router-outlet class="db-dashboard__router-outlet {{routeData?.pageId}}"></router-outlet>
              <db-loading-screen [ngClass]="{'hidden':!loadingPage}" [pageBlocker]="true"></db-loading-screen>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <db-activity-notifications></db-activity-notifications>
  <db-user-summaries *ngIf="routeData?.hasMainHeader"></db-user-summaries>

  <db-notifier></db-notifier>
  <!--<db-loading-workspace [workspaceName]="(switchWorkspace$ | async)?.workspaceName"
                        *ngIf="(switchWorkspace$ | async).switching && (switchWorkspace$ | async).redirect"></db-loading-workspace>-->
  <db-loading-screen [pageBlocker]="true"
                     *ngIf="(switchWorkspace$ | async).switching && !(switchWorkspace$ | async).redirect"></db-loading-screen>
</div>
<!--@if (userSubscription && user && Utils.isDemoUser(userSubscription, user)) {
  <db-demo-preview></db-demo-preview>
}-->
